<div class="bmc-excel-connector-container">
  <biz-excel-connector-list
    [connectors]="(connectors$ | async)"
    [selectedConnector]="(selectedConnector$ | async)"
    [isLoading]="(isLoadingConnectors$ | async)"
    (onSelectConnector)="applySelectConnector($event)">
  </biz-excel-connector-list>
  <biz-excel-connector-item-detail *ngIf="(connectors$ | async)?.length"
    [selectedConnector]="(selectedConnector$ | async)"
    [selectedVersionDetail]="currentDetailVersion"
    [isLoading]="(currentExcelConnectorIsLoading$ | async)"
    [isUploading]="(isUploadingExcelFile$ | async)"
    [selectedConnectorChild]="selectedConnectorChild"
    [resetInputFile]="resetInputFile"
    (save)="onSave()"
    (uploadFile)="onUploadFile($event)"
    (versionChanged)="onVersionChanged($event)"
    (download)="onDownload($event)"
    (cancel)="onCancel()">
    <h3 *ngIf="(connectors$ | async)?.length && !(selectedConnector$ | async).name">{{'EXCEL_CONNECTOR.SELECT_A_CONNECTOR' | translate}}</h3>
  </biz-excel-connector-item-detail>
  <div class="bmc-excel-connector-container__empty" *ngIf="(!(connectors$ | async) || !(connectors$ | async).length) && !(currentExcelConnectorIsLoading$ | async) && !(isLoadingConnectors$ | async)">
    <h3 *ngIf="!(selectedConnector$ | async).name">{{'EXCEL_CONNECTOR.EMPTY' | translate}}</h3>
  </div>
</div>